import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSearch24 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M10 11.4a6.3 6.3 0 1 1 1.4-1.4l4.6 4.6-1.4 1.4-4.6-4.6zm.6-5.1a4.3 4.3 0 1 1-8.6 0 4.3 4.3 0 0 1 8.6 0z",
		clipRule: "evenodd"
	})
});
export default SvgIconSearch24;
